import { render, staticRenderFns } from "./MatchOptionsPersonId.vue?vue&type=template&id=a0cfd5c4&scoped=true&"
import script from "./MatchOptionsPersonId.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsPersonId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cfd5c4",
  null
  
)

export default component.exports